import { useState } from "react";
import UploadScript from "../../../film-scripts/upload-script";
import Versions from "./versions";
import WarningText from "../../../shared/warning-text";
import Errors from "../../../shared/errors";

const Upload = (props) => {
    const { versions,
        progress,
        setUploadError,
        uploadScript,
        errors } = props;

    const [saving, setSaving] = useState(false);
    const isUploading = false;

    const onUpload = (formData) => {
        uploadScript(formData, props.history);
    };

    const setIsInProgress = (isInProgress) => {
        // This function can be used to set the upload progress state if needed
        // Currently, it does nothing as per the original code
    };

    return (
        <div>
            <WarningText>
                Only upload a new version if you have not changed the scene numbers, otherwise the results will be unpredictable.
            </WarningText>
            <Errors errors={errors} />
            <UploadScript isUploading={isUploading}
                setUploadError={setUploadError}
                progress={progress}
                saving={saving}
                setSaving={setSaving}
                onUpload={onUpload}
                setIsInProgress={setIsInProgress}
            />
            <Versions versions={versions} />
        </div>
    )
}

export default Upload;